module.exports = __webpack_public_path__ + "static/TheMetSans-LightItalic-6fa0de297ce4e9c4d1fc9a9361d96387.woff2";